import { handleActions } from 'redux-actions';
import { CAPS } from '../constants';

const init = {};

export default handleActions(
  {
    [CAPS.FEATURE_CONFIG_GET]: (state, { error, payload }) => {
      if (error) {
        return state;
      }

      return {
        ...state,
        ...payload.data,
      };
    },
  },
  init,
);
